import {
  HorizontalRectangle01,
  HorizontalRectangle02,
  HorizontalRectangle03,
  HorizontalRectangle04,
  HorizontalRectangle05,
  HorizontalRectangle06,
  HorizontalRectangle07,
  HorizontalRectangle08,
  HorizontalRectangle09,
  HorizontalRectangle10,
} from "./horizontalRectangles";

export const DEFAULT_HORIZONTAL_RECTANGLE_WIDTH = 1200;

export default function HorizontalRectangleShape({
  size,
  variantColor,
  shape,
  imageUrl,
  logoSrc = "",
  primaryText,
  secondaryText,
  callText,
  positions,
  x_axis = 50,
}) {
  switch (shape) {
    case 1:
    default:
      return (
        <HorizontalRectangle01
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 2:
      return (
        <HorizontalRectangle02
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 3:
      return (
        <HorizontalRectangle03
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 4:
      return (
        <HorizontalRectangle04
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 5:
      return (
        <HorizontalRectangle05
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 6:
      return (
        <HorizontalRectangle06
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 7:
      return (
        <HorizontalRectangle07
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 8:
      return (
        <HorizontalRectangle08
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 9:
      return (
        <HorizontalRectangle09
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 10:
      return (
        <HorizontalRectangle10
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
  }
}
